// extracted by mini-css-extract-plugin
export var btn = "button-module--btn--cf065";
export var btnClear = "button-module--btn-clear--b7cc4";
export var btnDefault = "button-module--btn-default--6c4c3";
export var btnIcon = "button-module--btnIcon--1dc04";
export var btnPrimary = "button-module--btn-primary--f0648";
export var btnSecondary = "button-module--btnSecondary--56252";
export var btnSmall = "button-module--btnSmall--f7a7d";
export var playButton = "button-module--play-button--9e128";
export var playButtonIcon = "button-module--play-button-icon--943ee";